<page-headline
    [linkTitle]="''"
    [module]="pageHeadline.module"
    [moduleIcon]="pageHeadline.moduleIcon"
    [moduleLink]="pageHeadline.moduleLink"
    [pageTitle]="pageHeadline.pageTitle"
    [linkArray]="pageHeadline.linkArray"
>
</page-headline>
<main-filters (filtersOutput)="applyNewFilters($event)"></main-filters>
<div class="displayopt-actionpanel-layout">
    <display-options
        (displayOptionsOutput)="applyDisplayOptions($event)"
        [extraParameters]="extraParameters"
    >
    </display-options>
    <action-panel
        [showExportCsv]="false"
        [showSaveAsPdf]="true"
        [showPrint]="false"
        [title]="pageHeadline.pageTitle"
    >
    </action-panel>
</div>
<div class="">
    <div class="performance-aag-card-container">
        <div class="performance-aag-card-area-left">
            <div class="row-layout-track layout-padding-bottom__1_5rem">
                <div
                    *ngFor="let cardId of smallCardIdArray.slice(0, 3)"
                    class="small-card-layout-box performance-aag-small-box"
                >
                    <ng-template customDashboardsOutlet [item]="cardId"></ng-template>
                </div>
            </div>
        </div>
        <div class="performance-aag-card-area-right">
            <div class="row-layout-track">
                <div
                    class="medium-small-card-layout-box performance-aag-meadium-box"
                    *ngFor="let cardId of smallCardIdArray.slice(3, 5)"
                >
                    <ng-template customDashboardsOutlet [item]="cardId"></ng-template>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="performance-aag-card-container">
    <div
        *ngFor="let cardId of largeCardIdArray.slice(0, 1)"
        class="performance-aag-card-area-left card-padding"
    >
        <ng-template customDashboardsOutlet [item]="cardId"></ng-template>
    </div>
    <div
        *ngFor="let cardId of largeCardIdArray.slice(1, 2)"
        class="performance-aag-card-area-right"
    >
        <ng-template customDashboardsOutlet [item]="cardId"></ng-template>
    </div>
</div>
